
import { createTransform } from 'redux-persist';
var CryptoJS = require("crypto-js");

export const encryptTransform = createTransform(
  (inboundState, key) => {
    // Encrypt the inbound state using the encryption key
    const ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      process.env.REACT_APP_EncryptionKey
    ).toString();
    return ciphertext;
  },
  (outboundState, key) => {
    // Decrypt the outbound state using the encryption key
    const bytes = CryptoJS.AES.decrypt(outboundState, process.env.REACT_APP_EncryptionKey);
    const decryptedState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedState;
  }
);
